import React, { useCallback, useContext, useEffect, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import DataState from 'app/src/components/DataState';
import { UPDATE_FEE } from 'app/src/components/Fees/queries';
import AuthContext from 'app/src/contexts/AuthContext';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';
import { currency } from 'app/src/utils/stringHelpers';

import { FIELDS, amountData, calculateAmount } from './new';

const EditFee = ({ asset, feeId, expenseAmount, onCompleted }) => {
  const { feeTypes, settings } = useContext(AuthContext);

  const [updateFee] = useMutation(UPDATE_FEE, { onCompleted: onCompleted });

  const fee = asset.fees.find(entry => entry.id === feeId);

  const {
    control, handleSubmit, watch, setValue, formState: { errors }
  } = useForm({
    defaultValues: defaultValues({
      fields: FIELDS,
      resource: fee,
    })
  });

  const values = watch();

  const onSubmit = input => {
    updateFee({
      variables: {
        ...input,
        assetId: asset.id,
        buyerFee: fee.buyerFee,
        saleAssetId: fee.saleAsset?.id,
      }
    });
  };

  const feeMarkups = feeTypes.map(feeType => (
    asset?.seller.feeMarkups.find(entry => entry.feeType === feeType.name) ||
      settings?.feeMarkups.find(entry => entry.feeType === feeType.name) ||
      {
        feeType: feeType.name,
        markupType: 'percent',
        amount: '0',
        defaultMarkup: true,
      }
  ));

  const feeMarkup = feeMarkups.find(entry => entry.feeType === values.type)
  const suggestedAmount = calculateAmount(expenseAmount, feeMarkup);

  useEffect(() => {
    if (suggestedAmount && values.type !== fee.type) {
      setValue('amount', suggestedAmount);
    }
  }, [suggestedAmount]);

  if (!settings || !asset) { return <DataState.Loading />; }

  const fields = { ...FIELDS };

  fields.type.select = feeTypes;

  if (feeMarkup) {
    const markupDescription = [
      'Markup: ',
      ('percent' === feeMarkup.markupType ? 'Percent' : 'Flat'),
      amountData(feeMarkup),
      (feeMarkup.defaultAmount ? '(System Default)' : ''),
    ].join(' ');

    fields.amount.hint = markupDescription;
  } else {
    fields.amount.hint = null;
  }

  return (
    <View>
      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Update Fee" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default EditFee;
